import React, { StrictMode } from 'react'
import * as ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'react-oidc-context'
import * as Sentry from '@sentry/react'
import { initSentry } from '@/sentry'
import { oidcConfig } from '@/auth/oidcConfig'
import App from '@/App'
import { CrashCard } from '@/components/common/CrashCard'
import '@/styles/globals.css'

initSentry()

// Dev-only axe-core integration. The guard uses Vite's static
// `import.meta.env.DEV` (replaced at build time) rather than our
// runtime `env.VITE_APP_ENV`, so the dynamic `import()` below is
// tree-shaken out of production bundles entirely — no ~500kB dead
// chunk shipped to real users. Violations surface in DevTools Console.
if (import.meta.env.DEV) {
  void import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000)
  })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider {...oidcConfig}>
        <Sentry.ErrorBoundary fallback={<CrashCard />}>
          <App />
        </Sentry.ErrorBoundary>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
